export default "__VITE_ASSET__BpNnJuiL__"